
import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import PoliticalAffiliationsListView from "./political_affiliations-list.html";
import PoliticalAffiliationsEditView from "./political_affiliations-edit.html";

angular.module("political_affiliations", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('political_affiliations', {
                url: "/political_affiliations",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('political_affiliations.list', {
                url: "/list",
                controller: "PoliticalAffiliationsListCtrl",
                template: PoliticalAffiliationsListView,
                cache: false,
                requiredPermission: ["POLITICAL_AFILIATION_READ"]
            })            
            .state('political_affiliations.edit', {
                url: "/edit/:id",
                controller: "PoliticalAffiliationsEditCtrl",
                template: PoliticalAffiliationsEditView,
                cache: false,
                requiredPermission: ["POLITICAL_AFILIATION_READ"]
            })
    }])
;